import {
  Button,
  ColumnLayout,
  Container,
  Form,
  FormField,
  Header,
  Select,
  SpaceBetween,
  Spinner,
  Textarea,
} from "@cloudscape-design/components-themed";
import { CONFIGS, LABELS } from "./constants";
import { formatLabel } from "../../utils/format";
import { useEffect } from "react";
import { COMMON_LABELS } from "../default-constants";
import { useAppDispatch, useAppSelector } from "../../app/hook";
import { showModal } from "../UI/modal/modal-slice";
import { getErrorText, isNull } from "../../utils/inputValidation";
import {
  InputNames,
  clearFormFieldErrTxt,
  createFormFieldErrTxts,
} from "../../features/error/validation-slice";

/**
 * ID払い出し結果受領・取込メイン表示部
 * ドロップダウンリスト表示内容が設定されていない(undefined)の場合ドロップダウンリストは非表示とする。
 *
 * @param props.priorPayoutIdName 事前払出ID名
 * @param props.callRegisterApi 登録API呼び出し処理
 * @param props.idList 入力IDリスト
 * @param props.setIdList 入力IDリスト設定処理
 * @param props.spinnerDisplayFlag スピナー表示フラグ
 * @param props.selectItem ドロップダウンリスト選択アイテム（省略可能）
 * @param props.selectItemName　ドロップダウンリスト表示名称（ドロップダウンリスト選択アイテムが設定されている場合必須）
 * @param props.selectList ドロップダウンリスト表示内容（ドロップダウンリスト選択アイテムが設定されている場合必須）
 * @param props.setSelectItem ドロップダウンリスト選択アイテム設定処理（ドロップダウンリスト選択アイテムが設定されている場合必須）
 * @param props.placeholder プレイスホルダーに表示するメッセージ
 */
const Main = (props: any) => {
  const dispatch = useAppDispatch();

  // ヘッダータイトル
  const headerTitle = formatLabel(LABELS.HEADER_TITLE, [
    props.priorPayoutIdName,
  ]);

  const { formFieldErrTxts } = useAppSelector((state) => state.validation);

  // 入力エラー表示用変数
  const idList = CONFIGS.ID_LIST as keyof InputNames;
  const selectItem = CONFIGS.SELECT_ITEM as keyof InputNames;

  // 初回のみエラーの初期化を行う
  useEffect(() => {
    dispatch(clearFormFieldErrTxt(selectItem));
    dispatch(clearFormFieldErrTxt(idList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 入力チェック
  const inputCheck = () => {
    let errorFlag = true;
    if (props.selectList !== undefined) {
      // ドロップダウンリストの必須チェック
      if (isNull(props.selectItem.value as string)) {
        dispatch(
          createFormFieldErrTxts({
            name: selectItem,
            msgId: "KGRERR023",
            msgArgs: [props.selectItemName],
          })
        );
        errorFlag = false;
      } else {
        dispatch(clearFormFieldErrTxt(selectItem));
      }
    }

    // 登録IDの必須チェック
    // 改行を空文字に変換しチェックする。
    const idListStr = props.idList as string;
    if (isNull(idListStr.replace(CONFIGS.LF_CODE, ""))) {
      dispatch(
        createFormFieldErrTxts({
          name: idList,
          msgId: "KGRERR023",
          msgArgs: [props.priorPayoutIdName],
        })
      );
      errorFlag = false;
    } else {
      dispatch(clearFormFieldErrTxt(idList));
    }

    return errorFlag;
  };
  // 登録ボタン押下処理
  const onClickButton = async () => {
    // 入力チェックNGの場合終了
    if (!inputCheck()) {
      return;
    }
    //　確認ダイアログ表示
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.REGISTER_CONFIRM,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        positiveFn: () => {
          props.callRegisterApi();
        },
      })
    );
  };

  return (
    <>
      <Container
        header={
          <Header variant="h2" description="">
            {headerTitle}
          </Header>
        }
      >
        <Form
          actions={
            <SpaceBetween direction="horizontal" size="l">
              {props.spinnerDisplayFlag && <Spinner size="big" />}
              <Button onClick={onClickButton} variant="primary">
                {COMMON_LABELS.BTNS.REGISTER}
              </Button>
            </SpaceBetween>
          }
        >
          <SpaceBetween direction="vertical" size="xxl">
            {props.selectList !== undefined && (
              <ColumnLayout columns={4}>
                <FormField
                  label={props.selectItemName}
                  errorText={getErrorText(
                    CONFIGS.SELECT_ITEM,
                    formFieldErrTxts
                  )}
                >
                  <Select
                    selectedOption={props.selectItem}
                    options={props.selectList}
                    filteringType="auto"
                    onChange={(event: any) => {
                      dispatch(clearFormFieldErrTxt(selectItem));
                      props.setSelectItem(event.detail.selectedOption);
                    }}
                  />
                </FormField>
              </ColumnLayout>
            )}
            <FormField
              label={props.priorPayoutIdName}
              errorText={getErrorText(CONFIGS.ID_LIST, formFieldErrTxts)}
            >
              <Textarea
                onChange={({ detail }) => {
                  dispatch(clearFormFieldErrTxt(idList));
                  props.setIdList(detail.value);
                }}
                value={props.idList}
                rows={10}
                placeholder={props.placeholder}
              />
            </FormField>
          </SpaceBetween>
        </Form>
      </Container>
    </>
  );
};

export default Main;
